"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;
var _react = _interopRequireDefault(require("react"));
var _reactIs = require("react-is");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function toArray(children) {
  var ret = [];
  _react.default.Children.forEach(children, function (child) {
    if (child === undefined || child === null) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if ((0, _reactIs.isFragment)(child) && child.props) {
      ret = ret.concat(toArray(child.props.children));
    } else {
      ret.push(child);
    }
  });
  return ret;
}